/* Llama Land cart A: authoritative, serialized Shopify cart operations.
 * Keeps UpCart's native quantity, removal, checkout and existing gift guards.
 * Never retries a paid add after an uncertain response.
 */
(function () {
  'use strict';
  if (window.LLCartACommerce) return;
  var config = window.LLCartAConfig || {};
  function enabled() {
    return config.enabled === true && !window.LN_B2B &&
      document.documentElement.classList.contains('ll-theme');
  }
  if (!enabled()) return;
  var products = Array.isArray(config.products) ? config.products : Object.keys(config.products || {}).map(function (key) {
    var product = config.products[key];
    if (!product.key) product.key = key;
    return product;
  });
  var planIds = config.planIds || {};
  var listeners = [], state = { cart: null, busy: false, error: null, reason: 'init' };
  var pendingRead = null, operation = null, nativeQuantityUntil = 0, nativeRefreshNeeded = false, nativeRefreshSignature = null;
  var routeRoot = String(config.routeRoot || '/');
  if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';
  var giftIds = (config.gifts && config.gifts.quarterly || []).concat(config.gifts && config.gifts.monthly || []).map(String);
  // Kids Sleep: a new subscription earns its own gift set on any path into the cart.
  var sleepGift = config.sleepGift || { handles: [], gifts: [] };
  var sleepGiftIds = sleepGift.gifts.map(String);
  var sleepGiftRepairs = 0;
  sleepGiftIds.forEach(function (id) { if (giftIds.indexOf(id) === -1) giftIds.push(id); });
  var kitGiftIds = (config.gifts && config.gifts.quarterly || []).concat(config.gifts && config.gifts.monthly || []).map(String);
  var milestone = config.milestone || {};
  var optOutStorageKey = 'll-cart-a-gift-optouts-v1';
  var giftOptOuts = [];
  var milestoneOverride = null, milestoneWatch = null;
  try {
    var savedOptOuts = JSON.parse(window.sessionStorage.getItem(optOutStorageKey) || '[]');
    if (Array.isArray(savedOptOuts)) giftOptOuts = savedOptOuts.map(String).filter(function (id) { return giftIds.indexOf(id) !== -1; });
  } catch (error) { /* Storage can be unavailable; this tab still honors intent. */ }

  function saveOptOuts() {
    try {
      if (giftOptOuts.length) window.sessionStorage.setItem(optOutStorageKey, JSON.stringify(giftOptOuts));
      else window.sessionStorage.removeItem(optOutStorageKey);
    } catch (error) { /* In-memory opt-outs still apply. */ }
  }
  function releaseMilestoneOverride() {
    if (milestoneOverride && milestoneOverride.owned && milestoneOverride.settings.gwp_subscription_gift_variant_id === null) {
      milestoneOverride.settings.gwp_subscription_gift_variant_id = milestoneOverride.original;
    }
    milestoneOverride = null;
    if (milestoneWatch) { clearInterval(milestoneWatch); milestoneWatch = null; }
  }
  function syncMilestoneOverride() {
    var id = String(milestone.variantId || '');
    var optedOut = id === String((config.gifts && config.gifts.monthly || [])[0] || '52033279623481') && giftIds.indexOf(id) !== -1 && giftOptOuts.indexOf(id) !== -1;
    if (!enabled() || !optedOut) { releaseMilestoneOverride(); return; }
    var settings = window.theme && window.theme.settings;
    if (milestoneOverride) {
      // A later settings writer owns its new value. Do not overwrite it.
      if (settings !== milestoneOverride.settings || settings.gwp_subscription_gift_variant_id !== null) {
        milestoneOverride.owned = false;
        if (milestoneWatch) { clearInterval(milestoneWatch); milestoneWatch = null; }
      }
      return;
    }
    if (settings && String(settings.gwp_subscription_gift_variant_id) === id) {
      milestoneOverride = { settings: settings, original: settings.gwp_subscription_gift_variant_id, owned: true };
      // gwp-manager reads this setting on every sync. Without this scoped opt-out
      // it immediately re-adds removed Stickers at four subscription units.
      // Cache/restore the original; never replace its hooks or compiled code.
      settings.gwp_subscription_gift_variant_id = null;
    }
    if (!milestoneWatch && typeof setInterval === 'function') milestoneWatch = setInterval(syncMilestoneOverride, 1000);
  }
  function noteGiftRemoval(id) {
    id = String(id);
    if (!enabled() || giftIds.indexOf(id) === -1 || !state.cart || !state.cart.items.some(function (item) { return isGift(item) && String(item.variant_id) === id; })) return false;
    if (giftOptOuts.indexOf(id) === -1) { giftOptOuts.push(id); saveOptOuts(); }
    syncMilestoneOverride();
    return true;
  }

  function fail(code, message, status) {
    var error = new Error(message);
    error.code = code;
    if (status) error.status = status;
    return error;
  }
  function emit(reason) {
    state.reason = reason;
    listeners.slice().forEach(function (listener) {
      try { listener(getState()); } catch (error) { /* A renderer cannot break a cart mutation. */ }
    });
  }
  function getState() {
    return { cart: state.cart, busy: state.busy, error: state.error, reason: state.reason };
  }
  function subscribe(listener) {
    if (typeof listener !== 'function') return function () {};
    listeners.push(listener);
    listener(getState());
    return function () { listeners = listeners.filter(function (item) { return item !== listener; }); };
  }
  function wait(milliseconds) {
    return new Promise(function (resolve) { setTimeout(resolve, milliseconds); });
  }
  function request(path, body, html) {
    if (!enabled()) return Promise.reject(fail('DISABLED', 'The cart is not available.'));
    var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: html ? 'text/html' : 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
      // A write can succeed even if its response is lost. Refresh native rows
      // after it, but do not refresh again after read-only confirmation.
      nativeRefreshNeeded = true;
    }
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
    if (controller) options.signal = controller.signal;
    return fetch(routeRoot + path, options).then(function (response) {
      if (response.status === 429) throw fail('RATE_LIMITED', 'The cart is busy. Please wait a moment and try again.', 429);
      if (html) {
        if (!response.ok) throw fail('REQUEST_FAILED', 'The offer could not be applied. Please try again.', response.status);
        return null;
      }
      return response.json().catch(function () { throw fail('INVALID_RESPONSE', 'The cart could not be confirmed. Please refresh it.'); }).then(function (data) {
        if (!response.ok) throw fail('REQUEST_FAILED', data.description || data.message || 'The cart could not be updated.', response.status);
        return data;
      });
    }).catch(function (error) {
      if (error.name === 'AbortError') throw fail('REQUEST_TIMEOUT', 'The update may have completed. Please check your cart before trying again.');
      throw error;
    }).finally(function () { if (timeout) clearTimeout(timeout); });
  }
  function isGift(item) {
    return item && item.product_type === 'Free Gift' && Number(item.original_price) === 0;
  }
  function excluded(item) {
    if (!item || isGift(item)) return true;
    var properties = item.properties || {};
    return ['_dynamicBoxId', '_is_hero_offer_bundle'].some(function (key) {
      return Object.prototype.hasOwnProperty.call(properties, key);
    });
  }
  function isSleepSub(item) {
    return !excluded(item) && !!item.selling_plan_allocation && sleepGift.handles.indexOf(item.handle) !== -1;
  }
  function productFor(item) {
    if (excluded(item)) return null;
    var matches = products.filter(function (product) {
      return (product.variants || []).some(function (variant) { return String(variant.id) === String(item.variant_id || item.id); });
    });
    return matches.length === 1 ? matches[0] : null;
  }
  function variantFor(product, item) {
    return (product.variants || []).filter(function (variant) { return String(variant.id) === String(item.variant_id || item.id); })[0] || null;
  }
  function planId(item) {
    var allocation = item.selling_plan_allocation;
    return allocation && allocation.selling_plan ? String(allocation.selling_plan.id) : null;
  }
  function planKind(item) {
    var id = planId(item);
    if (!id) return 'otp';
    if (String(planIds.monthly) === id) return 'monthly';
    if (String(planIds.quarterly) === id) return 'quarterly';
    return 'unknown';
  }
  function planMetadata(product, id) {
    var found = null;
    (product.selling_plan_groups || []).some(function (group) {
      found = (group.selling_plans || []).filter(function (plan) { return String(plan.id) === String(id); })[0] || null;
      return !!found;
    });
    return found;
  }
  function renewalPrice(product, variant, allocation) {
    var plan = planMetadata(product, allocation.selling_plan_id);
    var adjustments = plan && plan.price_adjustments || [];
    var ongoing = adjustments.filter(function (adjustment) { return adjustment.order_count == null; }).pop();
    if (!ongoing) return null;
    var prices = allocation.price_adjustments || [];
    var price = prices.filter(function (adjustment) { return Number(adjustment.position) === Number(ongoing.position); })[0];
    if (price && Number.isFinite(Number(price.price))) return Number(price.price);
    var base = Number(variant.price), value = Number(ongoing.value);
    if (!Number.isFinite(base) || !Number.isFinite(value)) return null;
    if (ongoing.value_type === 'percentage') return Math.max(0, Math.round(base * (1 - value / 100)));
    if (ongoing.value_type === 'fixed_amount') return Math.max(0, base - value);
    if (ongoing.value_type === 'price') return value;
    return null;
  }
  function plansFor(item) {
    var product = productFor(item);
    if (!product) return null;
    var variant = variantFor(product, item);
    var kind = planKind(item);
    // Legacy, LP, Dynamic Box, and 180-count plans retain their native controls.
    if (!variant || kind === 'unknown') return null;
    var plans = { kind: kind, otp: variant.requires_selling_plan ? null : { id: null, price: Number(variant.price), renewalPrice: null }, monthly: null, quarterly: null };
    ['monthly', 'quarterly'].forEach(function (name) {
      var allocation = (variant.selling_plan_allocations || []).filter(function (candidate) { return String(candidate.selling_plan_id) === String(planIds[name]); })[0];
      if (!allocation || variant.available === false || !planMetadata(product, allocation.selling_plan_id)) return;
      plans[name] = { id: Number(allocation.selling_plan_id), price: Number(allocation.price), renewalPrice: renewalPrice(product, variant, allocation) };
    });
    return plans;
  }
  function adopt(cart, reason, confirmedExternal) {
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(Number(cart.total_price))) throw fail('INVALID_CART', 'The cart could not be confirmed. Please refresh it.');
    var previous = state.cart;
    state.cart = cart;
    if (!cart.items.length && giftOptOuts.length) { giftOptOuts = []; saveOptOuts(); }
    syncMilestoneOverride();
    // Confirmations commonly return the identical cart. Repainting it wakes
    // the legacy DOM listeners, which each request the cart again.
    var signature = stable(cart);
    // Another gift/discount writer can change Shopify's response without one
    // of our POSTs. Its new prices still need to reach UpCart's native rows.
    if (state.busy && nativeRefreshSignature !== null && nativeRefreshSignature !== signature) nativeRefreshNeeded = true;
    if (!previous || stable(previous) !== signature) emit(reason || 'cart');
    // Native quantity/removal controls still own paid changes. Reconcile only
    // when paid lines changed: opening the drawer or removing a gift must never
    // add that gift back. This repairs milestone-owned Stickers after a native
    // removal takes a quarterly cart from four subscription units to three.
    var paidChanged = previous && paidSignature(previous) !== paidSignature(cart) &&
      previous.items.concat(cart.items).some(function (item) { return !!plansFor(item) || isSleepSub(item); });
    // Legacy restores start after the native request resolves, not at click.
    if (paidChanged && !state.busy && nativeQuantityUntil) nativeQuantityUntil = Date.now() + 5700;
    var restoredOptOut = cart.items.some(function (item) { return isGift(item) && giftOptOuts.indexOf(String(item.variant_id)) !== -1; });
    // A buy box add with a code confirms the cart itself, so gifts it earned can still be missing here.
    var sleepGiftMissing = sleepGiftRepairs < 3 && cart.items.some(isSleepSub) && expectedGifts(cart).some(function (id) {
      return sleepGiftIds.indexOf(String(id)) !== -1 && !cart.items.some(function (item) { return isGift(item) && String(item.variant_id) === String(id); });
    });
    if (sleepGiftMissing) sleepGiftRepairs++;
    if (!state.busy && ((!confirmedExternal && paidChanged) || restoredOptOut || sleepGiftMissing)) {
      transact(async function () {
        await wait(650);
        var fresh = await fetchCart();
        var expected = paidExpectations(fresh);
        var eligibleUnits = quarterlyUnits(fresh);
        var keepCode = codeApplied(fresh, config.coupon) || (previous && eligibleUnits >= 3 && codeApplied(previous, config.coupon));
        var code = keepCode ? config.coupon : null;
        // Native writers often leave a correct cart. Confirm that cart quickly
        // instead of locking its controls through the full legacy timer window.
        if (!Object.keys(giftFixes(fresh)).length && codeApplied(fresh, code) && !milestoneWillRemoveEarnedGift(fresh)) return fresh;
        return settle(expected, code, false, fresh);
      }, true).catch(function () { /* State/error subscribers own the visible response. */ });
    }
    return cart;
  }
  function fetchCart() {
    if (pendingRead) return pendingRead;
    pendingRead = request('cart.js').then(function (cart) { return adopt(cart, 'cart'); }).finally(function () { pendingRead = null; });
    return pendingRead;
  }
  function readCart() {
    // External read requests wait for the full transaction, rather than painting
    // a paid-line-only intermediate cart while gifts and the offer are settling.
    if (operation) return operation.then(function () { return state.cart; }, function () { return state.cart || fetchCart(); });
    return fetchCart();
  }
  function stable(value) {
    if (value == null || typeof value !== 'object') return JSON.stringify(value);
    if (Array.isArray(value)) return '[' + value.map(stable).join(',') + ']';
    return '{' + Object.keys(value).sort().map(function (key) { return JSON.stringify(key) + ':' + stable(value[key]); }).join(',') + '}';
  }
  function sameIdentity(item, identity) {
    return String(item.variant_id) === String(identity.variantId) && planId(item) === identity.planId &&
      stable(item.properties || {}) === identity.properties;
  }
  function quantityFor(cart, identity) {
    return cart.items.filter(function (item) { return sameIdentity(item, identity); }).reduce(function (total, item) { return total + Number(item.quantity); }, 0);
  }
  function assertPaid(cart, expected) {
    if (Array.isArray(expected)) { expected.forEach(function (item) { assertPaid(cart, item); }); return; }
    if (quantityFor(cart, expected) !== expected.quantity) throw fail('CART_CHANGED', 'Your cart changed while updating. Please check the items and try again.');
  }
  function paidExpectations(cart, targets) {
    var grouped = {};
    cart.items.forEach(function (item) {
      if (isGift(item)) return;
      var target = (targets || []).filter(function (entry) { return entry.key === item.key; })[0];
      var identity = { variantId: item.variant_id, planId: target ? target.planId : planId(item), properties: stable(item.properties || {}) };
      var key = stable(identity);
      if (!grouped[key]) grouped[key] = Object.assign({}, identity, { quantity: 0 });
      grouped[key].quantity += target ? target.quantity : Number(item.quantity);
    });
    return Object.keys(grouped).map(function (key) { return grouped[key]; });
  }
  function paidSignature(cart) {
    var grouped = {};
    paidExpectations(cart).forEach(function (identity) {
      var properties = JSON.parse(identity.properties);
      // This UpCart bookkeeping flag does not change gift/offer eligibility.
      // Keep it in mutation identity and cart data; ignore it only as a trigger.
      delete properties.__upcartSubscriptionEdit;
      var key = stable({ variantId: identity.variantId, planId: identity.planId, properties: stable(properties) });
      grouped[key] = (grouped[key] || 0) + identity.quantity;
    });
    return Object.keys(grouped).sort().map(function (key) { return key + ':' + grouped[key]; }).join('|');
  }
  function quarterlyUnits(cart, changedItem, changedKind, changedQuantity) {
    return cart.items.reduce(function (total, item) {
      if (!productFor(item)) return total;
      var kind = item === changedItem ? changedKind : planKind(item);
      return kind === 'quarterly' ? total + (item === changedItem ? changedQuantity : Number(item.quantity)) : total;
    }, 0);
  }
  function subscriptionUnits(cart) {
    return cart.items.reduce(function (count, item) {
      var properties = item.properties || {};
      return !item.selling_plan_allocation || properties._gwp_source || properties._is_hero_offer_bundle === 'true' ? count : count + Number(item.quantity);
    }, 0);
  }
  function expectedGifts(cart) {
    var tier = null;
    cart.items.forEach(function (item) {
      if (!productFor(item)) return;
      var kind = planKind(item);
      if (kind === 'quarterly') tier = 'quarterly';
      else if (kind === 'monthly' && !tier) tier = 'monthly';
    });
    var earned = (tier && config.gifts && config.gifts[tier] || []).slice();
    if (cart.items.some(isSleepSub)) sleepGift.gifts.forEach(function (id) { if (earned.indexOf(id) === -1) earned.push(id); });
    return earned.filter(function (id) { return giftOptOuts.indexOf(String(id)) === -1; });
  }
  function llKitSets(items) {
    /* one gift set per kid (Brad 2026-10-20): largest kids subscription line, in kids (3-Month = 3 jars per kid), 1..4 */
    var n = 0;
    (items || []).forEach(function (it) {
      if (!it || !it.selling_plan_allocation || it.product_type === 'Free Gift') return;
      var kids = it.product_type === 'Kids' || /^kids\b(?!\s*&)/i.test(it.product_title || '');
      if (!kids) return;
      var sp = it.selling_plan_allocation.selling_plan || {};
      var per = (String(sp.id) === '703006540089' || /3[\s-]*month/i.test(sp.name || '')) ? 3 : 1;
      n = Math.max(n, Math.floor(Number(it.quantity) / per));
    });
    return Math.max(1, Math.min(4, n || 1));
  }
  window.LL_GIFTS_PER_KID = true; /* opt-in flag read by the UpCart gift-guard (Brad 2026-10-20) */
  var LL_KIT_GIFTS = [52033279623481, 51105405043001, 54280090452281, 53658225574201, 53731422142777, 54115717579065];
  function llGiftTarget(variantId, items) { return LL_KIT_GIFTS.indexOf(Number(variantId)) > -1 ? llKitSets(items) : 1; }
  function giftFixes(cart) {
    var updates = {}, seen = {};
    var anySub = cart.items.some(function (item) { return !!item.selling_plan_allocation; });
    var desired = expectedGifts(cart).map(String);
    var knownSubscriptionScope = cart.items.every(function (item) {
      return !item.selling_plan_allocation || isGift(item) || !!plansFor(item) || isSleepSub(item);
    });
    cart.items.forEach(function (item) {
      // Retention/purchased gifts and unrelated app gifts are outside this adapter.
      if (!isGift(item) || giftIds.indexOf(String(item.variant_id)) === -1) return;
      if (!anySub || giftOptOuts.indexOf(String(item.variant_id)) !== -1 || ((knownSubscriptionScope || kitGiftIds.indexOf(String(item.variant_id)) === -1) && desired.indexOf(String(item.variant_id)) === -1) || seen[String(item.variant_id)]) updates[item.key] = 0;
      else if (Number(item.quantity) !== llGiftTarget(item.variant_id, cart.items)) updates[item.key] = llGiftTarget(item.variant_id, cart.items);
      seen[String(item.variant_id)] = true;
    });
    expectedGifts(cart).forEach(function (id) { if (!seen[String(id)]) updates[String(id)] = llGiftTarget(id, cart.items); });
    return updates;
  }
  function codeApplied(cart, code) {
    return !code || (cart.discount_codes || []).some(function (discount) { return String(discount.code).toUpperCase() === String(code).toUpperCase() && discount.applicable === true; });
  }
  function refreshNative() {
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      else document.dispatchEvent(new CustomEvent('cart:refresh'));
      nativeRefreshNeeded = false;
      nativeRefreshSignature = state.cart ? stable(state.cart) : null;
    } catch (error) { /* The authoritative cart is still available to the renderer. */ }
  }
  function milestoneWillRemoveEarnedGift(cart) {
    var id = String(milestone.variantId || '');
    return subscriptionUnits(cart) < Number(milestone.minimum || 4) && expectedGifts(cart).map(String).indexOf(id) !== -1 &&
      cart.items.some(function (item) { return isGift(item) && String(item.variant_id) === id && (item.properties || {})._gwp_source === 'subscription_milestone'; });
  }
  async function tagMilestone(cart) {
    var id = String(milestone.variantId || '');
    if (!id || giftIds.indexOf(id) === -1 || giftOptOuts.indexOf(id) !== -1 || subscriptionUnits(cart) < Number(milestone.minimum || 4)) return cart;
    var index = cart.items.findIndex(function (item) { return isGift(item) && String(item.variant_id) === id; });
    if (index === -1 || (cart.items[index].properties || {})._gwp_source === 'subscription_milestone') return cart;
    var properties = Object.assign({}, cart.items[index].properties || {}, { _gwp_source: 'subscription_milestone', _gwp_free: 'true', __upcartFreeGift: 'true' });
    return adopt(await request('cart/change.js', { line: index + 1, quantity: Number(cart.items[index].quantity) || 1, properties: properties }), 'cart');
  }
  async function repair(cart, expected, code) {
    assertPaid(cart, expected);
    var updates = giftFixes(cart);
    if (Object.keys(updates).length) {
      cart = adopt(await request('cart/update.js', { updates: updates }), 'cart');
      assertPaid(cart, expected);
    }
    cart = await tagMilestone(cart);
    if (code && !codeApplied(cart, code)) {
      // The cart endpoint returns the authoritative total without following a
      // discount redirect and downloading a full storefront page. Preserve
      // other entered codes when updating the list.
      var codes = (cart.discount_codes || []).map(function (discount) { return discount.code; });
      if (!codes.some(function (value) { return String(value).toUpperCase() === String(code).toUpperCase(); })) codes.push(code);
      cart = adopt(await request('cart/update.js', { discount: codes.join(',') }), 'cart');
    }
    assertPaid(cart, expected);
    return cart;
  }
  function confirmCart(cart, expected, code) {
    assertPaid(cart, expected);
    return !Object.keys(giftFixes(cart)).length && codeApplied(cart, code) && !milestoneWillRemoveEarnedGift(cart);
  }
  async function settle(expected, code, ownedChange, initialCart) {
    var started = Date.now();
    async function checkpoint(milliseconds) {
      var remaining = milliseconds - (Date.now() - started);
      if (remaining > 0) await wait(remaining);
    }
    // change.js/update.js return a complete authoritative cart. Reuse that
    // response; add.js returns only the added items and still needs a read.
    var cart = await repair(initialCart || await fetchCart(), expected, code);
    if (nativeRefreshNeeded) refreshNative();
    // Our own plan/add writes do not schedule the legacy set-stepper's gift
    // restores. Confirm two settled reads instead of imposing its five-second
    // timer on every action. A preceding native step retains that full window.
    if (ownedChange && Date.now() >= nativeQuantityUntil) {
      var stableReads = 0, nextConfirmation = Date.now() + 650;
      for (var attempt = 0; attempt < 4; attempt++) {
        // Network time counts toward the confirmation interval. Slow mobile
        // responses must not incur another full idle delay after each read.
        var pause = nextConfirmation - Date.now();
        if (pause > 0) await wait(pause);
        nextConfirmation = Date.now() + 650;
        cart = await fetchCart();
        if (confirmCart(cart, expected, code)) stableReads++;
        else { stableReads = 0; cart = await repair(cart, expected, code); }
        if (stableReads >= 2) return cart;
      }
    }
    // Existing native gift/quantity listeners run at 2.5 and 5 seconds. Keep the
    // purchase controls locked until these windows have passed, then confirm.
    await checkpoint(2700);
    cart = await repair(await fetchCart(), expected, code);
    await checkpoint(5400);
    cart = await repair(await fetchCart(), expected, code);
    await checkpoint(Math.max(5700, nativeQuantityUntil - started));
    cart = await fetchCart();
    assertPaid(cart, expected);
    if (Object.keys(giftFixes(cart)).length) throw fail('GIFTS_UNCONFIRMED', 'Your item was updated, but the free gifts could not be confirmed. Please refresh the cart.');
    if (!codeApplied(cart, code)) throw fail('OFFER_UNAVAILABLE', 'Your item was updated, but the discount was not applied. Please check the total before checkout.');
    return cart;
  }
  function transact(work, reconcileNative) {
    if (state.busy) return Promise.reject(fail('BUSY', 'Please wait for the current cart update.'));
    nativeRefreshSignature = state.cart ? stable(state.cart) : null;
    state.busy = true;
    state.error = null;
    emit('start');
    operation = Promise.resolve().then(async function () {
      // Finish a read already underway before writing, so its stale result
      // cannot overwrite the post-mutation snapshot.
      if (pendingRead) await pendingRead;
      // Native reconciliation already starts from an authoritative read and
      // reads again after its guard delay. It has no paid write to preflight.
      // Paid actions still read after any earlier request has finished: that
      // earlier request may have started before another native cart write.
      var cart = reconcileNative ? null : await fetchCart();
      return work(cart);
    }).catch(async function (error) {
      state.error = error;
      // Do not retry a paid write. A lost response can still mean it succeeded.
      // A 429 stops requests for this action, including this recovery read.
      if (error.code !== 'RATE_LIMITED') {
        try { await fetchCart(); } catch (readError) { if (readError.code === 'RATE_LIMITED') state.error = readError; }
      }
      throw state.error;
    }).finally(function () {
      operation = null;
      state.busy = false;
      emit(state.error ? 'error' : 'complete');
      if (nativeRefreshNeeded && (!state.error || state.error.code !== 'RATE_LIMITED')) refreshNative();
    });
    return operation;
  }
  function removeLastItem(itemKey) {
    return transact(async function (cart) {
      var paid = cart.items.filter(function (item) { return !isGift(item); });
      if (paid.length !== 1 || paid[0].key !== itemKey || !plansFor(paid[0]) ||
          cart.items.some(function (item) { return isGift(item) && giftIds.indexOf(String(item.variant_id)) === -1; })) {
        throw fail('CART_CHANGED', 'Your cart changed. Please check the items and try again.');
      }
      // Remove the final paid line and its known free gifts in one write.
      // Native per-line removal otherwise exposes a gift-only cart and races
      // the legacy gift cleanup against another update using expired line keys.
      var updates = {};
      cart.items.forEach(function (item) { updates[item.key] = 0; });
      return adopt(await request('cart/update.js', { updates: updates }), 'cart');
    });
  }
  function changePlan(itemKey, kind) {
    return transact(async function (cart) {
      if (['otp', 'monthly', 'quarterly'].indexOf(kind) === -1) throw fail('INVALID_PLAN', 'That delivery option is not available.');
      var matching = cart.items.filter(function (item) { return item.key === itemKey; });
      if (matching.length !== 1) throw fail('CART_CHANGED', 'Your cart changed. Please choose the delivery option again.');
      var item = matching[0], plans = plansFor(item);
      if (!plans || !plans[kind]) throw fail('INVALID_PLAN', 'That delivery option is not available for this item.');
      if (plans.kind === kind) return cart;
      var quantity = Number(item.quantity);
      if (!Number.isInteger(quantity) || quantity < 1) throw fail('INVALID_QUANTITY', 'Please check the item quantity.');
      if (plans.kind === 'quarterly') {
        if (quantity % 3) throw fail('INVALID_QUANTITY', 'Please adjust the 3-month quantity before changing its delivery option.');
        quantity /= 3;
      }
      if (kind === 'quarterly') quantity *= 3;
      var identity = { variantId: item.variant_id, planId: plans[kind].id == null ? null : String(plans[kind].id), properties: stable(item.properties || {}) };
      identity.quantity = quantityFor(cart, identity) + quantity;
      // Shopify requires line (not key) when changing a selling plan. Resolve it
      // from this just-read cart; omit properties so existing line data survives.
      var changedCart = adopt(await request('cart/change.js', { line: cart.items.indexOf(item) + 1, quantity: quantity, selling_plan: plans[kind].id }), 'cart');
      var retainedCode = null;
      if (kind === 'quarterly') retainedCode = config.coupon;
      else if (codeApplied(cart, config.coupon)) {
        var eligibleUnits = quarterlyUnits(cart, item, kind, quantity);
        if (eligibleUnits >= 3) retainedCode = config.coupon;
      }
      return settle(identity, retainedCode, true, changedCart);
    });
  }
  function bulkPlans(kind, allOtpOnly) {
    return transact(async function (cart) {
      var paid = cart.items.filter(function (item) { return !isGift(item); });
      if (allOtpOnly && (!paid.length || !paid.every(function (item) { var plans = plansFor(item); return plans && plans.kind === 'otp' && plans.monthly; }))) {
        throw fail('CART_CHANGED', 'Your cart changed. Please choose a delivery option for each item.');
      }
      var targets = paid.filter(function (item) {
        var plans = plansFor(item);
        return plans && plans[kind] && (allOtpOnly ? plans.kind === 'otp' : plans.kind === 'monthly');
      }).map(function (item) {
        var plans = plansFor(item), quantity = Number(item.quantity);
        if (!Number.isInteger(quantity) || quantity < 1) throw fail('INVALID_QUANTITY', 'Please check the item quantity.');
        return { key: item.key, from: { variantId: item.variant_id, planId: planId(item), properties: stable(item.properties || {}), quantity: quantity }, planId: String(plans[kind].id), quantity: kind === 'quarterly' ? quantity * 3 : quantity };
      });
      if (!targets.length) throw fail('CART_CHANGED', 'Your cart changed. Please choose a delivery option again.');
      var expected = paidExpectations(cart, targets);
      var changedCart;
      for (var i = 0; i < targets.length; i++) {
        if (i) cart = await fetchCart();
        var target = targets[i];
        var matches = cart.items.filter(function (item) { return sameIdentity(item, target.from); });
        if (matches.length !== 1 || Number(matches[0].quantity) !== target.from.quantity) throw fail('CART_CHANGED', 'Your cart changed while updating. Please check the items and try again.');
        changedCart = adopt(await request('cart/change.js', { line: cart.items.indexOf(matches[0]) + 1, quantity: target.quantity, selling_plan: Number(target.planId) }), 'cart');
      }
      return settle(expected, kind === 'quarterly' ? config.coupon : null, true, changedCart);
    });
  }
  function addMonthly(productKey, variantId) {
    return transact(async function (cart) {
      var matches = products.filter(function (product) { return product.key === productKey; });
      if (matches.length !== 1) throw fail('INVALID_PRODUCT', 'This item is not available.');
      var product = matches[0];
      if (cart.items.some(function (item) { var match = productFor(item); return match && match.key === productKey; })) throw fail('ALREADY_PRESENT', 'This item is already in your cart.');
      var variants = (product.variants || []).filter(function (variant) { return variant.available !== false && (!variantId || String(variant.id) === String(variantId)); });
      var variant = variants.filter(function (candidate) { return (candidate.selling_plan_allocations || []).some(function (allocation) { return String(allocation.selling_plan_id) === String(planIds.monthly); }); })[0];
      if (!variant) throw fail('INVALID_PRODUCT', 'The monthly option is not available for this item.');
      var plans = plansFor({ variant_id: variant.id, properties: {} });
      if (!plans || !plans.monthly) throw fail('INVALID_PLAN', 'The monthly option is not available for this item.');
      var expected = { variantId: variant.id, planId: String(plans.monthly.id), properties: stable({}), quantity: 1 };
      var retainedCode = codeApplied(cart, config.coupon) ? config.coupon : null;
      await request('cart/add.js', { items: [{ id: Number(variant.id), quantity: 1, selling_plan: plans.monthly.id }] });
      return settle(expected, retainedCode, true);
    });
  }
  function addCrossSell(productKey) {
    // Recommendation-only products (config.crossSells): one Monthly unit.
    // They stay outside productFor(), so gift rules and plan controls are unchanged.
    return transact(async function (cart) {
      var matches = (config.crossSells || []).filter(function (product) { return product.key === productKey; });
      if (matches.length !== 1) throw fail('INVALID_PRODUCT', 'This item is not available.');
      var product = matches[0];
      if (cart.items.some(function (item) { return item.handle === product.handle && !isGift(item); })) throw fail('ALREADY_PRESENT', 'This item is already in your cart.');
      var crossPlanId = product.planId || planIds.monthly;
      var variant = (product.variants || []).filter(function (candidate) {
        return candidate.available !== false && (candidate.selling_plan_allocations || []).some(function (allocation) { return String(allocation.selling_plan_id) === String(crossPlanId); });
      })[0];
      if (!variant) throw fail('INVALID_PRODUCT', 'The monthly option is not available for this item.');
      var expected = { variantId: variant.id, planId: String(crossPlanId), properties: stable({}), quantity: quantityFor(cart, { variantId: variant.id, planId: String(crossPlanId), properties: stable({}) }) + 1 };
      var retainedCode = codeApplied(cart, config.coupon) ? config.coupon : null;
      await request('cart/add.js', { items: [{ id: Number(variant.id), quantity: 1, selling_plan: Number(crossPlanId) }] });
      return settle(expected, retainedCode, true);
    });
  }
  // Chain the PDP's hook; do not let UpCart refresh midway through our add.
  var previousSkip = window.upcartShouldSkipAddToCart;
  window.upcartShouldSkipAddToCart = function (url) {
    if (state.busy && String(url || '').indexOf('/cart/add') !== -1) return true;
    return typeof previousSkip === 'function' ? previousSkip.apply(this, arguments) : false;
  };
  window.LLCartACommerce = {
    readCart: readCart, changePlan: changePlan, addMonthly: addMonthly, addCrossSell: addCrossSell, removeLastItem: removeLastItem,
    acceptConfirmedCart: async function (cart) {
      // PDP owns this verified add. Drain older reads before adopting its result;
      // do not start a second gift transaction for the same completed add.
      if (pendingRead) await pendingRead.catch(function () {});
      if (operation) await operation.catch(function () {});
      var unchanged = state.cart && stable(state.cart) === stable(cart);
      state.error = null;
      var result = adopt(cart, 'confirmed-external', true);
      if (unchanged) emit('confirmed-external');
      return result;
    },
    noteNativeQuantityMutation: function () { nativeQuantityUntil = Date.now() + 5700; },
    noteGiftRemoval: noteGiftRemoval,
    upgradeMonthly: function () { return bulkPlans('quarterly', false); },
    subscribeAll: function () { return bulkPlans('monthly', true); },
    subscribe: subscribe, getBusy: function () { return state.busy; }, getState: getState,
    productFor: productFor, plansFor: plansFor, isGift: isGift
  };
  syncMilestoneOverride();
})();
